import React from 'react';
import { ActiveAuction } from 'src/lib/GlobalDataContext';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { MegaMenuLink } from './MegaMenuLink';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);

export const MegaMenuUpcomingAuction = ({ auction, index }: {auction: ActiveAuction, index: number}) => {
  const { megaMenuState } = useMegaMenu();
  const startDate = dayjs(auction.StartDate);
  const endDate = dayjs(auction.EndDate);

  const formatDateRange = () => {
    if(startDate.isSame(endDate, 'month')) {
      return `${startDate.format('MMMM Do')} - ${endDate.format('Do')}`;
    } else {
      return `${startDate.format('MMMM Do')} - ${endDate.format('MMMM Do')}`;
    }
  };

  const location = auction.AuctionTypeID == TIMED_AUCTION_TYPE_ID
    ? 'Online'
    : `${auction.LocCity}, ${auction.LocState}`;

  return (
    <div className='flex flex-col gap-1'>
      <MegaMenuLink
        to={`/gun-auctions/${auction.Slug || auction.AuctionID}`}
        label={auction.Title}
        id={`mega-menu-upcoming-auction-${index + 1}`}
        onPress={() => megaMenuState.close()}
        description={<>
          <div>{formatDateRange()}</div>
          <div>{location}</div>
        </>}
      />
    </div>
  );
};
